module.exports = __webpack_public_path__ + "8791cd767d217e535ca0eb9571383ac3.pdf";